<template>
  <p class="text-center alert alert-secondary patreon-characters">
    Adventure Waits for You <strong>HERO</strong>!
    You have reached your limit of characters.<br />
    To embark on new quests and create <strong>additional characters</strong>,
    please support us on <strong><a href="https://www.patreon.com/EmbersRPGVault" target="patreon">Patreon</a></strong>.<br />
    Your support unlocks endless possibilities!
  </p>
</template>

<script>
export default {
  name: "patreon-card",
};
</script>

<style lang="scss" scoped>
@import "../../assets/_global";

  .patreon-characters {
    font-size: 1.25em;
  }
</style>